import { render, staticRenderFns } from "./numInputItem.vue?vue&type=template&id=13979c80"
import script from "./numInputItem.vue?vue&type=script&lang=js"
export * from "./numInputItem.vue?vue&type=script&lang=js"
import style0 from "./numInputItem.vue?vue&type=style&index=0&id=13979c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports